<template lang='pug'>
  i.svg-icon.svg-icon-followDoctor
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M49.998,49.161c12.313,0,22.296-9.982,22.296-22.295c0-12.313-9.982-22.295-22.296-22.295 c-12.314,0-22.293,9.981-22.296,22.292c0,12.313,9.979,22.297,22.294,22.297C49.996,49.161,49.996,49.161,49.998,49.161z')

      path(d='M66.721,54.841v8.542c6.488,1.334,11.142,7.035,11.146,13.656v7.265c-0.005,1.324-0.946,2.462-2.243,2.723l-5.611,1.111 c-0.75,0.154-1.479-0.329-1.633-1.079c0-0.005,0-0.005,0-0.005l-0.543-2.724c-0.153-0.745,0.319-1.478,1.07-1.633 c0.005,0,0.01,0,0.015-0.005l3.366-0.675v-4.989c0-10.934-16.72-11.333-16.72,0.335v4.648l3.361,0.681 c0.744,0.16,1.223,0.883,1.09,1.632l-0.548,2.724c-0.159,0.744-0.883,1.229-1.632,1.09l-5.445-0.733 c-1.384-0.187-2.41-1.372-2.404-2.771v-7.621c0.026-6.615,4.695-12.306,11.173-13.629V55.5c-0.383,0.122-0.766,0.191-1.149,0.335 c-6.471,2.276-13.523,2.276-19.995,0c-1.277-0.441-2.596-0.744-3.938-0.909v14.216c5.161,1.537,8.099,6.972,6.56,12.131 c-1.537,5.163-6.972,8.1-12.133,6.563c-5.161-1.542-8.097-6.972-6.56-12.137c0.941-3.153,3.409-5.621,6.56-6.557V55.134 c-11.256,1.872-19.513,11.599-19.525,23.012v7.801c0.005,4.309,3.494,7.802,7.804,7.808h62.428c4.308-0.006,7.801-3.499,7.807-7.808 v-7.801C88.993,65.675,79.181,55.415,66.721,54.841z')
      
      path(d='M76.035,48.142v3.827c0,1.586,1.287,2.872,2.875,2.872c1.586,0,2.873-1.286,2.873-2.872v-3.827h3.823 c1.585,0,2.872-1.287,2.872-2.873s-1.287-2.872-2.872-2.872h-3.823v-3.771c0-1.587-1.287-2.872-2.873-2.872 c-1.588,0-2.875,1.285-2.875,2.872v3.77h-3.771c-1.59,0-2.874,1.287-2.874,2.872c0,1.587,1.284,2.874,2.874,2.874L76.035,48.142 L76.035,48.142z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#77b530',
    },
  },

}
</script>